// extracted by mini-css-extract-plugin
export var container = "NextPrev-module--container--1cCDt";
export var prev = "NextPrev-module--prev--9W8y3";
export var withPrev = "NextPrev-module--withPrev--3SIO3";